import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=4bc1d7a9&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=js&"
export * from "./main-footer.vue?vue&type=script&lang=js&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=4bc1d7a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1d7a9",
  null
  
)

export default component.exports